import React, { useMemo } from 'react';
import { Chessboard } from 'react-chessboard';
import { Chess } from 'chess.js';
import { BOARD_LIGHT_SQUARE, BOARD_DARK_SQUARE } from '../../theme';

const PREVIEW_PLIES = 8;

/**
 * Board Thumbnail Component
 * Single Responsibility: Static preview of a course's characteristic position
 */
const BoardThumbnail = ({ id, moves = [], orientation = 'white' }) => {
  const fen = useMemo(() => {
    const game = new Chess();
    for (const move of moves.slice(0, PREVIEW_PLIES)) {
      try {
        game.move(move);
      } catch (error) {
        break;
      }
    }
    return game.fen();
  }, [moves]);

  return (
    <div className="w-full aspect-square rounded-xl overflow-hidden pointer-events-none ring-1 ring-black/20">
      <Chessboard
        options={{
          id: `thumbnail-${id}`,
          position: fen,
          boardOrientation: orientation,
          allowDragging: false,
          showNotation: false,
          lightSquareStyle: BOARD_LIGHT_SQUARE,
          darkSquareStyle: BOARD_DARK_SQUARE,
          animationDurationInMs: 0
        }}
      />
    </div>
  );
};

export default BoardThumbnail;
